import { useEffect, useState } from 'react';
import { Flex, useBreakpointValue } from '@chakra-ui/react';

import DTSearch from './DTSearch';
import DTTable from './DTTable';
import DTCards from './DTCards';
import DTPaginate from './DTPaginate';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import { TituloDTO } from '../../../dtos/TituloDTO';

interface DTTituloParams {
	data: TituloDTO[];
	setTituloModal: (financeiro: FinJsonDTO) => void;
	setModalTituloVisible: (open: boolean) => void;
	setModalTituloEditVisible: (open: boolean) => void;
	setModalTituloDeleteVisible: (open: boolean) => void;
	titulosBaixa: FinJsonDTO[];
	setTitulosBaixa: (titulos: FinJsonDTO[]) => void;
}

const DTTitulo: React.FC<DTTituloParams> = ({
	data,
	setTituloModal,
	setModalTituloVisible,
	setModalTituloEditVisible,
	setModalTituloDeleteVisible,
	titulosBaixa,
	setTitulosBaixa,
}) => {

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const [loading, setLoading] = useState(true);

	const [pesqTitulos, setPesqTitulos] = useState<TituloDTO[]>(data);
	const [titulos, setTitulos] = useState<TituloDTO[]>(data);

  const [sort, setSort] = useState({ por: '', cres: true });
  const [controls, setControls] = useState({
    page: 1,
    perPage: 10,
    totalPage: Math.ceil(data.length / 10),
  });

	const [parcsBaixa, setParcsBaixa] = useState<string[]>([]);
	const [pagesBaixa, setPagesBaixa] = useState<number[]>([]);

  useEffect(() => {
    setTitulos(data.slice(0, 10));
    setLoading(false);
  }, []);

  async function handleUpdateList(
    page: number,
    perPage: number,
    tituloss: TituloDTO[],
  ) {
    const auxPage = page - 1;
    const start = auxPage * perPage;
    const end = start + perPage;

		setTitulos(tituloss.slice(start, end));
  }

  return (
    <Flex w="100%" flexDir="column" __css={{
			overflow: 'auto',
			overflowX: 'auto',
			scrollbarWidth: 'thin !important',
			scrollBehavior: 'smooth',

			'&::-webkit-scrollbar': {
				display: 'block !important',
				visibility: 'visible !important',
			},
			'&::-webkit-scrollbar-track': {
				background: '#eeeef2',
				borderRadius: '10px'
			},
			'&::-webkit-scrollbar-thumb': {
				background: '#d1d2dc',
				maxHeight: '10px',
				borderRadius: '10px'
			}
		}}>
			<DTSearch
        titulos={data}
        setPesqTitulos={setPesqTitulos}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />

      {isWideVersion && (
				<DTTable
					titulos={titulos}
					pesqTitulos={pesqTitulos}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
					setTituloModal={setTituloModal}
					setModalTituloVisible={setModalTituloVisible}
					setModalTituloEditVisible={setModalTituloEditVisible}
					setModalTituloDeleteVisible={setModalTituloDeleteVisible}
					titulosBaixa={titulosBaixa}
					setTitulosBaixa={setTitulosBaixa}
					parcsBaixa={parcsBaixa}
					setParcsBaixa={setParcsBaixa}
					pagesBaixa={pagesBaixa}
					setPagesBaixa={setPagesBaixa}
				/>
      )}

      {!isWideVersion && !loading && (
				<DTCards
					controls={controls}
					titulos={titulos}
					setTituloModal={setTituloModal}
					setModalTituloVisible={setModalTituloVisible}
					setModalTituloEditVisible={setModalTituloEditVisible}
					setModalTituloDeleteVisible={setModalTituloDeleteVisible}
					titulosBaixa={titulosBaixa}
					setTitulosBaixa={setTitulosBaixa}
					parcsBaixa={parcsBaixa}
					setParcsBaixa={setParcsBaixa}
					pagesBaixa={pagesBaixa}
					setPagesBaixa={setPagesBaixa}
				/>
			)}

      <DTPaginate
				titulos_length={data.length}
        pesq_length={pesqTitulos.length}
        pesqTitulos={pesqTitulos}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />
    </Flex>
  );
};

export default DTTitulo;
